// app/javascript/controllers/offers_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["offerableFields"]

  offerableTypeChanged(event) {
    const offerableType = event.target.value
    const url = `/offers/offerable_fields?type=${offerableType}`

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'text/html'
      }
    })
      .then(response => response.text())
      .then(html => {
        this.offerableFieldsTarget.innerHTML = html
      })
  }
}